<!-- 认知重建 填写 卡片组件 -->
<template>
  <div>
    <div class="chat-card">
      <div class="card">
        <ChatReport v-model="reportValue" :columns="reportList" />
      </div>
      <div class="card">
        <MultipleInput
          ref="ideaFormItemsRef"
          :init-form-items="ideaFormItems"
          name="*被质疑的想法"
        />
      </div>
      <div class="card">
        <MultipleInput
          ref="confirmFormItemsRef"
          :init-form-items="confirmFormItems"
          name="*我确定吗?"
        />
      </div>
      <div class="card">
        <MultipleInput
          ref="actualFormItemsRef"
          :init-form-items="actualFormItems"
          name="*实际情况会有多糟?"
        />
      </div>
      <div class="card">
        <MultipleInput
          ref="beforeFormItemsRef"
          :init-form-items="beforeFormItems"
          name="以前发生过什么?"
        />
      </div>
      <div class="card">
        <ChatTextarea
          v-model="formTextarea.other"
          mask-placeholder="点击输入我的回答"
          question="有什么其他的问题可以用来检验我的想法？我会怎么回答它？"
        />
      </div>
      <div class="tips">*请至少填写一项问题。</div>
      <div class="card">
        <ChatTextarea
          v-model="formTextarea.new"
          mask-placeholder="点击输入我的回答"
          question="*在经历这些问题的思考后，想想，现在我们可以用什么新方式来看待这样的情境呢？"
        />
      </div>
      <div class="card">
        <ChatTextarea
          v-model="formTextarea.newTrustworthiness"
          mask-placeholder="点击输入我的回答"
          question="*现在你对这个新的替代想法的相信程度有多少呢？（0-100%）"
        />
      </div>
      <div class="card">
        <ChatTextarea
          v-model="formTextarea.oldTrustworthiness"
          mask-placeholder="点击输入我的回答"
          question="*对于此前的旧想法你的相信程度有多少呢？（0-100%）"
        />
      </div>
      <div class="card">
        <!-- <div class="card-input">{{ reportList[reportValue]?.report.response }}</div> -->
        <QuestionSelect
          :columns="mentalTrapsList"
          v-model="selectValue"
          question="*你认为此前的旧想法意味着可能陷入什么样的思维陷阱中呢？"
          @input="onSelect"
        />
      </div>
      <div class="card">
        <ChatTextarea
          v-model="formTextarea.newEmotion"
          mask-placeholder="点击输入我的回答"
          question="*现在你感受到的情绪是什么样的呢？"
        />
      </div>
      <div class="card">
        <ChatTextarea
          v-model="formTextarea.oldEmotion"
          mask-placeholder="点击输入我的回答"
          question="*在当时的情境中感受到的那些情绪，在使用新想法后有变化吗？给它们打上一个新分数。"
        />
      </div>
      <div class="card">
        <ChatTextarea
          v-model="formTextarea.practice"
          mask-placeholder="点击输入我的回答"
          question="*现在你在这样的情境下，你会做什么？你的行为会发生什么改变吗？结果会有所不同吗？"
        />
      </div>
      <div class="tips">*必填项目。</div>
      <button v-if="isCanEdit" class="confirm-btn" @click="confirmFn">确定</button>
    </div>
    <!-- <div v-if="cardData.isShowTime" class="send-time">09月01日 16:29</div> -->
  </div>
</template>

<script>
import ChatReport from "@/components/AIChatting/ChatReport/index.vue";
import MultipleInput from "@/components/AIChatting/MultipleInput/index.vue";
import { autoThoughtRecognitionList } from "@/api/autoThoughtRecognition";
import ChatTextarea from "@/components/AIChatting/ChatTextarea/index.vue";
import QuestionSelect from "@/components/AIChatting/QuestionSelect/index.vue";

export default {
  name: "ChatText",
  props: {
    cardData: {
      type: Object,
      default() {
        return {
          isShowTime: true,
        };
      },
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    ChatReport,
    MultipleInput,
    ChatTextarea,
    QuestionSelect,
  },
  data() {
    return {
      selectValue: 0,
      reportValue: 0,
      reportList: [],
      ideaFormItems: [
        {
          value: "",
          type: "ChatInput",
        },
        {
          value: "",
          examples:
            "你对这个想法的相信程度有多少呢？0%表示完全不相信，100%表示非常确信，用百分数来表示吧。",
          type: "ChatInput",
        },
      ],
      confirmFormItems: [
        {
          value: "",
          examples: "1.我百分之百确定我所想的事情会发生吗?",
          type: "ChatInput",
        },
        {
          value: "",
          examples: "2.我有什么证据支持这种害怕或信念吗?",
          type: "ChatInput",
        },

        {
          value: "",
          examples: "3.我能未卜先知吗?我怎么能肯定我知道答案？",
          type: "ChatInput",
        },

        {
          value: "",
          examples: "4.可能有其他解释吗?",
          type: "ChatInput",
        },

        {
          value: "",
          examples: "5.我是否因为强烈的情绪而错过了其他可能发生的事情?",
          type: "ChatInput",
        },
      ],
      actualFormItems: [
        {
          value: "",
          examples: "1.可能发生的最坏结果是什么?有多糟糕?",
          type: "ChatInput",
        },
        {
          value: "",
          examples: "2.如果我所想的事情真的发生了，我处理得了吗?我会如何处理?",
          type: "ChatInput",
        },

        {
          value: "",
          examples: "3.那又怎么样?",
          type: "ChatInput",
        },

        {
          value: "",
          examples: "4.我在过去处理过类似的事情吗?",
          type: "ChatInput",
        },

        {
          value: "",
          examples: "5.如果我所想的事情真的发生了，会有什么好的结果吗?",
          type: "ChatInput",
        },
      ],
      beforeFormItems: [
        {
          value: "",
          examples: "1.过去在这种情境下发生了什么?",
          type: "ChatInput",
        },
        {
          value: "",
          examples: "2.根据我过去对这种情境的经验，最常发生的是什么?",
          type: "ChatInput",
        },

        {
          value: "",
          examples: "3.其他人在这种情境下会怎么样?",
          type: "ChatInput",
        },
      ],
      formTextarea: {
        other: "",
        new: "",
        newTrustworthiness: "",
        oldTrustworthiness: "",
        newEmotion: "",
        oldEmotion: "",
        practice: "",
        twelveMentalTraps: {
          value: 0,
          label: "",
        },
      },
      mentalTrapsList: [
        { text: "非黑即白", label: "非黑即白", value: 1 },
        { text: "贴标签", label: "贴标签", value: 2 },
        { text: "灾难化思维", label: "灾难化思维", value: 3 },
        { text: "感情用事", label: "感情用事", value: 4 },
        { text: "低估或贬低正性信息", label: "低估或贬低正性信息", value: 5 },
        { text: "夸大或缩小", label: "夸大或缩小", value: 6 },
        { text: "选择性提取", label: "选择性提取", value: 7 },
        { text: "以偏概全", label: "以偏概全", value: 8 },
        { text: "读心症", label: "读心症", value: 9 },
        { text: "个人化或揽责上身", label: "个人化或揽责上身", value: 10 },
        { text: "应该和必须声明", label: "应该和必须声明", value: 11 },
        { text: "管状视野", label: "管状视野", value: 12 },
      ],
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    // 获取自动思维报告列表
    getList() {
      autoThoughtRecognitionList()
        .then((res) => {
          let useData = res.filter((item) => !!item.reprot);
          useData = useData.map((item) => {
            const report = JSON.parse(item.reprot);
            return {
              id: item.id,
              report: report,
              title: `自动化思维识别总结报告`,
              label: `自动化思维报告 ${report.time}`,
              content: `
              <p class="p"> 日期/时间：${report.time} </p>
              <p class="p"> 情境：${report.scene} </p>
              <p class="p"> 自动化思维：${report.autoThought} </p>
              <p class="p"> 情绪和生理反应：${report.response} </p>
              <p class="p"> 行为和/或结果：${report.result} </p>
            `,
            };
          });
          this.reportList = useData;
          console.log("自动化思维？？", useData);
        })
        .catch((err) => console.log(err));
    },
    setReportValue(id) {
      const findIndex = this.reportList.findIndex((item) => item.id === id);
      console.log(id, findIndex);
      this.reportValue = findIndex;
    },
    // 提交数据
    confirmFn() {
      const ideaFormItems = this.$refs.ideaFormItemsRef.getValues();
      const confirmFormItems = this.$refs.confirmFormItemsRef.getValues();
      const actualFormItems = this.$refs.actualFormItemsRef.getValues();
      const beforeFormItems = this.$refs.beforeFormItemsRef.getValues();
      if (
        !(
          ideaFormItems.filter((item) => item).length &&
          confirmFormItems.filter((item) => item).length &&
          actualFormItems.filter((item) => item).length
        )
      ) {
        return this.$toast("请至少填写一项问题");
      }
      if (
        !(
          this.formTextarea.new &&
          this.formTextarea.newTrustworthiness &&
          this.formTextarea.oldTrustworthiness &&
          this.formTextarea.newEmotion &&
          this.formTextarea.oldEmotion &&
          this.formTextarea.practice
        )
      ) {
        return this.$toast("请输入必填项");
      }
      let useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type,
                answer: {
                  reportData: this.reportList[this.reportValue].report,
                  autoThoughtId: this.reportList[this.reportValue].id,
                  ideaFormItems,
                  confirmFormItems,
                  actualFormItems,
                  beforeFormItems,
                  formTextarea: this.formTextarea,
                },
              },
            ],
          },
        },
      };
      this.$emit("confirmFn", useData);
    },
    onSelect(value) {
      this.formTextarea.twelveMentalTraps = {
        value: value,
        label: this.mentalTrapsList[value].label,
      };
      console.log(value);
      console.log(this.selectValue);
      console.log(this.formTextarea.twelveMentalTraps);
    },
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  width: 100%;
  .card {
    width: 100%;
    background: rgba(232, 227, 252, 1);
    padding: 15px;
    box-sizing: border-box;
    border-radius: 10px;
    margin-bottom: 10px;
    .card-text {
      box-sizing: border-box;
      padding: 0 0.75rem;
      font-size: 0.75rem;
      font-weight: 500;
      line-height: 1.4375rem;
      color: rgb(59, 59, 59);
      margin-bottom: 0.625rem;
    }
    .card-input {
      width: 100%;
      line-height: 23px;
      border-radius: 48px;
      background: rgba(255, 255, 255, 1);
      font-size: 10px;
      font-weight: 500;
      color: rgba(106, 106, 106, 1);
      margin-top: 10px;
      padding: 0 14px;
      box-sizing: border-box;
    }
  }
  .tips {
    font-size: 10px;
    font-weight: 500;
    line-height: 23px;
    color: rgba(121, 72, 234, 0.62);
    margin-top: -10px;
  }
}
.confirm-btn {
  width: 76px;
  height: 25px;
  border-radius: 12px;
  background: #ad7eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.23px;
  color: #fff;
  border: none;
  margin: 10px auto 0;
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
</style>
